import { render } from "./workView.vue?vue&type=template&id=6465545e&scoped=true"
import script from "./workView.vue?vue&type=script&lang=js"
export * from "./workView.vue?vue&type=script&lang=js"

import "./workView.vue?vue&type=style&index=0&id=6465545e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6465545e"]])

export default __exports__